import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField
} from '@mui/material';

import { useState, useRef, Ref, forwardRef } from 'react';
import { SubmitButton } from './SubmitButton';
import { registerEvaluation, ReviewInfo } from './RegisterEvaluation';
import { PageName, ReservationInfo } from './Index';

export function ReviewSendForm(props: any) {
  const [open, setOpen] = useState(false);

  let q1AnswerRef = useRef<HTMLDivElement>(null);
  let q2AnswerRef = useRef<HTMLDivElement>(null);
  let q1OtherRef = useRef<HTMLInputElement>(null);
  let q2OtherRef = useRef<HTMLInputElement>(null);

  const q1AnswerList = [
    '特に不満がない',
    '医師の説明が不十分',
    '医師に相談しにくかった',
    '医師の説明がわからなかった',
    '看護師やスタッフのケアが雑だった',
    '施術が痛すぎた',
    '施術の事前の説明が不十分だった',
    '自宅での過ごし方やケアがわからない',
    'スタッフの体臭、口臭が気になる'
  ];
  const q2AnswerList = [
    '特に不満がない',
    '予約システムが使いにくい',
    '院内誘導がわかりにくい',
    'ケアや診療情報が見にくい',
    '紙の案内が欲しい',
    'LINEをできれば使用したくない',
    '予約が取りにくい',
    '診療以外のスタッフの対応が不適切',
    '院内でわからないことを質問できなかった',
    '待ち時間が長い',
    '事前の診療時間の案内がわからなかった',
    'スタッフの体臭、口臭が気になる',
    '施設内の匂い(階下のレストラン)が気になった',
    '院内が不衛生',
    '診察室内が不衛生',
    'トイレが不衛生、ちらかっている'
  ];

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mb={2} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  ご感想をお聞かせください。
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  当クリニックのサービス向上のため、
                  <br />
                  貴重なご感想をお聞かせください。
                  <br />
                  皆様の声を参考に、より良い診療環境を
                  <br />
                  提供できるよう努めてまいります。
                </Typography>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <QuestionTitle
                  index={1}
                  title="診療内容にご不満だった点がございましたら、率直にご指摘をお願いいたします。"
                />
                <Grid container direction={'column'} mb={4}>
                  <Grid item xs={12} mt={1}>
                    <QuestionCheckList questions={q1AnswerList} ref={q1AnswerRef} />
                  </Grid>
                  <Grid item xs={12} mt={2.5}>
                    <Typography textAlign={'left'} fontSize={'14px'} className="font-bold">
                      その他（自由にご記入お願いいたします。）
                    </Typography>
                    <EtcTextField placeHolder="改善点やご意見を記入してください。" ref={q1OtherRef} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <QuestionTitle
                  index={2}
                  title="院内環境にご不満だった点がございましたら、率直にご指摘をお願いいたします。"
                />
                <Grid container direction={'column'}>
                  <Grid item xs={12} mt={1}>
                    <QuestionCheckList questions={q2AnswerList} ref={q2AnswerRef} />
                  </Grid>
                  <Grid item xs={12} mt={2.5}>
                    <Typography textAlign={'left'} fontSize={'14px'} className="font-bold">
                      その他（自由にご記入お願いいたします。）
                    </Typography>
                    <EtcTextField placeHolder="改善点やご意見を記入してください。" ref={q2OtherRef} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <SubmitButton
                  label={'送信する'}
                  onClick={async () => {
                    let q1Answer: string[] = getCheckedList(q1AnswerRef.current!.querySelectorAll('input'));
                    let q2Answer: string[] = getCheckedList(q2AnswerRef.current!.querySelectorAll('input'));
                    let q1Other = q1OtherRef.current!.value;
                    let q2Other = q2OtherRef.current!.value;
                    const reviewInfo: ReviewInfo = {
                      evaluation: props.rating,
                      q1answer: q1Answer,
                      q1other: q1Other,
                      q2answer: q2Answer,
                      q2other: q2Other
                    };
                    setOpen(true);
                    await registerEvaluation(props.reservationInfo as ReservationInfo, reviewInfo);
                    props.setActivePage(PageName.AfterLow);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

interface QuestionTitleProps {
  index: number;
  title: string;
}

const QuestionTitle = (props: QuestionTitleProps) => {
  return (
    <Grid container direction={'row'}>
      <Grid item xs={'auto'}>
        <Typography m={0} pr={1} fontSize={'16px'} color={'#A08B64'} className="font-bold">
          {`Q${props.index}.`}
        </Typography>
      </Grid>
      <Grid item xs textAlign={'left'}>
        <Typography m={0} p={0} fontSize={'16px'} className="font-bold">
          {props.title}
        </Typography>
        <Typography m={0} p={0} fontSize={'14px'}>
          （複数選択可能）
        </Typography>
      </Grid>
    </Grid>
  );
};

interface QuestionCheckListProps {
  questions: string[];
}

const QuestionCheckList = forwardRef((props: QuestionCheckListProps, ref: Ref<HTMLDivElement>) => {
  return (
    <FormGroup ref={ref}>
      {props.questions.map((q, i) => {
        return (
          <div key={`q${i}`} style={{ textAlign: 'left' }}>
            <FormControlLabel
              control={<Checkbox sx={{ padding: '10px' }} value={q} />}
              label={<Typography fontSize="14px">{q}</Typography>}
            />
          </div>
        );
      })}
    </FormGroup>
  );
});

interface EtcTextFieldProps {
  placeHolder: string;
}

const EtcTextField = forwardRef((props: EtcTextFieldProps, ref: Ref<HTMLInputElement>) => {
  return (
    <TextField
      inputRef={ref}
      sx={{ marginTop: '0.5rem' }}
      fullWidth
      multiline
      minRows={4}
      placeholder={props.placeHolder}
    />
  );
});

function getCheckedList(nodeList: NodeListOf<HTMLInputElement>): string[] {
  let qList: string[] = [];
  nodeList.forEach((node) => {
    if (node.checked) qList.push(node.value);
  });
  return qList;
}
